import { stepName as firstStep } from '../../../components/process/generic/Cancellation/CancellationForm'
import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const initialState = {
  step: firstStep,
  cancellationData: {}
}

const CancellationModule = {
  namespaced: true,
  state: initialState,
  actions: {
    async confirmCancellation ({ commit, state, rootGetters, getters }, { cancellationData, nextStep = 'cancellationSuccess' }) {
      commit('clearMessages', {}, { root: true })
      commit('setCancellationData', cancellationData)
      const brand = rootGetters.brand
      const apolloClient = getProvider().defaultClient

      return apolloClient.mutate({
        mutation: gql`mutation cancellationForm ($contractTerminationInput: ContractTerminationInput!){
          contractTermination (contractTermination: $contractTerminationInput){
            success,
            createdAt,
            caseNumber,
            address {
              firstName,
              lastName,
              street,
              houseNumber,
              zip,
              city
            },
            customer {
              email,
              terminationId {
                customerId,
                msisdnOrContractId
              },
              terminationData {
                date,
                details
              }
            }
            document {
              document
              type
            }
          }
        }`,
        variables: {
          contractTerminationInput: {
            address: {
              firstName: cancellationData.customer.firstName,
              lastName: cancellationData.customer.lastName,
              street: cancellationData.address.street,
              houseNumber: cancellationData.address.houseNumber,
              zip: cancellationData.address.zip,
              city: cancellationData.address.city
            },
            customer: {
              email: cancellationData.email,
              terminationId: {
                customerId: cancellationData.customer.customerID,
                msisdnOrContractId: cancellationData.customer.contractID
              },
              terminationData: {
                date: cancellationData.preferredCancellationDate,
                details: cancellationData.details
              }
            },
            brand: brand,
            captcha: {
              code: cancellationData.captcha.captchaCode,
              token: cancellationData.captcha.captchaToken
            }
          }
        }
      }).then((response) => {
        commit('setCancellationData', response.data.contractTermination)
        commit('Transaction/removeTransactionId', 'cancellationForm', { root: true })
        commit('changeStep', nextStep)
        return response.data.success
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
        return false
      })
    }
  },
  mutations: {
    changeStep (state, step) {
      state.step = step
    },
    setCancellationData (state, cancellationData) {
      state.cancellationData = cancellationData
    }
  },
  getters: {
    getStep (state) {
      return state.step
    },
    getCancellationData (state) {
      return state.cancellationData
    }
  }
}

export {
  CancellationModule
}
